import { render, staticRenderFns } from "./MyCollectionCategoryTree.vue?vue&type=template&id=0b3272a0&scoped=true"
import script from "./MyCollectionCategoryTree.vue?vue&type=script&lang=js"
export * from "./MyCollectionCategoryTree.vue?vue&type=script&lang=js"
import style0 from "./MyCollectionCategoryTree.vue?vue&type=style&index=0&id=0b3272a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3272a0",
  null
  
)

export default component.exports